<template>

    <div>
         <div class="banner">
                <div class="banner-search">
                        <div>
                            <div class="search-item">
                                <p>小区展示</p>
                                <div></div>    
                            </div>
                        </div>
                    </div>
                    <el-carousel class="banner-imgs" :interval="8000" indicator-position="none">
                        <el-carousel-item v-for="(bannerImg, index) in bannerList" :key="index">
                            <a :href="bannerImg.urlAddr">
                                <img
                                    :src="bannerImg.url?bannerImg.url:require('@/assets/imgs/banner_zc.png')"
                                    style="width:100%;height:100%;"
                                />
                            </a>
                        </el-carousel-item>
                    </el-carousel>
                </div>
    
        <div class="content" id='houseList' style="margin-top:0">
            <div class="w">
            <div class="condition">
                <div id="breadcrumb" class="l">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                        <el-breadcrumb-item>小区展示</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
    
                <div v-if="keywordHide"> <!-- 模糊查询时,不显示关键字 -->
                    <div class='l serachWord' v-for="item in serachWord" :key="item.id">
                        <div class="l" v-if="item.name">
                            <span>{{item.name}}</span>
                            <i class="el-icon-close" @click="removeSearchWord(item.id)"></i>
                        </div>
                    </div>
                </div>
    
                <div id="mapSearch" class="r" @click="mapSearch">
                      <el-button
                        slot="append"
                        class="mapSearch"
                        type="primary"
                        icon="el-icon-location-information"
                        @click="mapSearch"
                      >地图找房</el-button>
                </div>
    
                <div id="search" class="r">
                     <el-input
                      v-model="keyword"
                      class="input-with-select"
                      type="text"
                    ></el-input>
                    <el-button type="primary" @click="search">搜索</el-button>
                </div>
                <div class="clear"></div>
            </div>
    
            <div id="division">
            </div>
    
            <div class="group">
                <div class="row" :style="{height: dyHeight}" v-if="streetTownNavData.length>0">
                    <div >
                        <div class="head">
                            <span>区域</span>
                        </div>
                        <div class="body">
                            <div>
                                <a>
                                    <span @click="navSearch()">不限</span>
                                </a>
                                <div v-for="item in streetTownNavData" :key="item.code" @click="navSearch(item.code,item.name,1)">
                                    <a>
                                        <span>{{item.name}}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
               <div class="row" :style="{height: dyHeight}" v-if="metroNavData.length>0">
                    <div >                    
                        <div class="head">
                            <span>地铁</span>
                        </div>
                        <div class="body">
                            <div>
                                <div v-for="item in metroNavData" :key="item.code" @click="navSearch(item.id,item.name,2)">
                                    <a>
                                        <span>{{item.name}}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="row" :style="{height: dyHeight}" v-if="bussinessNavData.length>0">
                    <div >                    
                        <div class="head">
                            <span>商圈</span>
                        </div>
                        <div class="body">
                            <div>
                                <div v-for="item in bussinessNavData" :key="item.code" @click="navSearch(item.id,item.name,3)">
                                    <a>
                                        <span>{{item.name}}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
             <div class="maincontent">
              <el-row>
                <el-col :span="8" v-for="(housing, index) in HousingList" :key="index" :offset="index > 0 ? 1 : 0">
                  <el-card :body-style="{ padding: '0px' }" shadow="hover" @click.native="gotoDetail(housing.id)">
                    <div class="img">
                        <el-image :src=housing.cover style="width: 370px; height: 278px">
                            <div slot="error" class="image-slot">
                                <img :src="require('@/assets/imgs/pic.jpg')" style="width: 370px; height: 278px">
                            </div>
                        </el-image>
                    </div>
                    
                    <div class="desc">
                      <div class="housing-intro">
                        <div class="community-name" :title="housing.name">
                          {{housing.name}}
                        </div>
                        <!-- <div class="housing-price">
                            <div v-if="housing.rental>0">
                                ￥{{housing.rental}}元 起/月
                            </div>
                        </div> -->
                      </div>
                      <div class="housing-addr">
                        <img :src="require('@/assets/imgs/position-smaill.png')" />
                        &nbsp;{{housing.address}}
                      </div>
                      <div class="housing-props" v-if="housing.props != null && housing.props.length > 0">
                          <el-row>
                            <el-col :span="4" v-for="(prop , pindex) in housing.props" :key="pindex" :offset="pindex > 0 ? 1: 0">
                              <el-button plain size="mini">
                                {{prop}}
                              </el-button>
                            </el-col>
                          </el-row>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
    
             <div id="page">
                 <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :total="total"
                    :page-size="pageSize">
                </el-pagination>
             </div>
        </div>
        </div>
        </div>
    </template>
    
    <script>
    import PortalApi from "@/api/portal/index";
    export default{
        data(){
            return{
                total:0,
                pageSize:9,
                keyword:"",
                code:"",
                streetTownNavData:[],
                metroNavData:[],
                bussinessNavData:[],
                serachWord:[],
                dyHeight:'60px',
                HousingList: [],
                bannerList: [
                {
                    url: require("@/assets/imgs/banner_zc.png"),
                    urlAddr: "#",
                }],
                keywordHide:true
            }
        },
        activated(){
            this.getData();
        },
        watch: {
            // 监控query不同时，重新获取数据
            $route(to, from) {
                if(to.name == from.name && to.query != from.query){
                    this.getData();
                }
            },
        },
        methods:{
            getData(){
                PortalApi.getNavInfo()
                .then(
                    res=>{
                        var data = res.data;
                        this.streetTownNavData = data.streetTownList;
                        this.metroNavData = data.metroTownList;
                        this.bussinessNavData = data.bussinessTownList;
                        //this.total = res.count;
                    }
                )
    
                this.serachWord = [];
    
                // 从首页过来的
                if(this.$route.query.keyword){
                    this.serachWord = [{id:"",type:"0",name:this.$route.query.keyword}];
                }
    
                if(this.$route.query.type){
                    this.serachWord = [{id:"",type:this.$route.query.type,name:""}];
                }
    
                PortalApi.getCommunityList(1,9,this.serachWord)
                .then(
                    res=>{
                        this.HousingList = res.data;
                        this.total = res.count;
                    }
                )
            },
            handleCurrentChange(val){
                PortalApi.getCommunityList(val,9,this.serachWord)
                .then(
                    res=>{
                        this.HousingList = res.data;
                        this.total = res.count;
    
                        window.scrollTo(0,290);
                    }
                )
            },
            gotoDetail(id){ 
                const routeUrl = this.$router.resolve({
                    path: "/HouseDetail",
                    query: { id: id },
                    });
                window.open(routeUrl.href, "_blank");
                //this.$router.push({ path: "/HouseDetail", query: { id: id} });
            },
            mapSearch(){
                this.$router.push({ path: "/MapSearch" });
            },
            search(){
               this.serachWord = [{id:"",type:"0",name:this.keyword}];
               this.keywordHide = false;
                PortalApi.getCommunityList(1,9,this.serachWord)
                    .then(
                        res=>{
                            this.HousingList = res.data;
                            this.total = res.count;
                            }
                    );
            },
            
            // type 1 街道，2 地铁，3 商圈
            navSearch(id,name,type){ 
                this.serachWord = [];
                this.keyword = "";
                this.keywordHide = true;
                if(id == undefined){ // 不限
                    PortalApi.getCommunityList(1,9,this.serachWord)
                    .then(
                        res=>{
                            this.HousingList = res.data;
                            this.total = res.count;
                            }
                    );
                    return;
                }
                this.serachWord = this.serachWord.reduce((total, current) => {
                    current.type !== type && total.push(current);
                    return total;
                }, []);
    
                this.serachWord.push({
                    id:id,
                    name:name,
                    type:type
                });
                PortalApi.getCommunityList(1,9,this.serachWord)
                    .then(
                        res=>{
                            this.HousingList = res.data;
                            this.total = res.count;
                            }
                    );
            },
            removeSearchWord(id){
               this.serachWord = this.serachWord.reduce((total, current) => {
                current.id !== id && total.push(current);
                return total;
            }, []);
             PortalApi.getCommunityList(1,9,this.serachWord)
                    .then(
                        res=>{
                            this.HousingList = res.data;
                            this.total = res.count;
                            }
                    );
            }
        }
    }
    
    </script>
    
    <style lang="scss" scoped>
    #houseList{
        .w{
            width:1170px;
            margin: 0 auto;
        }
        .l{
            float:left;
        }
        .r{
            float:right;
        }
        .clear{
            clear: both;
        }
       
        #breadcrumb,#search,#mapSearch,.serachWord{
            display: flex;
            align-items: center;
            text-align: justify;
            height:60px;
            color:#fff;
        }
        .serachWord div{
            color:#999999;
            margin-left: 20px;
            padding :0 16px 0 5px;
            font-size: 16px;
            height: 20px;
            border:1px solid #e8e8e8;
            position: relative;
        }
        .serachWord div i{
            width: 10px;
            height: 10px;
            position: absolute;
            right: 0;
            top: 0;
            font-size: 10px;
            margin-right: 3px;
        }
        #division{
            border-top: 1px solid #DEDEDE;
            margin-bottom: 20px;
        }
        .input-with-select /deep/.el-input__inner{
            width: 264px;
            height: 35px;
            border-radius: 0;
        }
        #search button,#mapSearch button{
            width: 54px;
            height: 35px;
            font-size: 12px;
            border-radius: 0;
            padding:0;
        }
        #search button span{
            display: block;
            width: 54px;
            height: 35px;
            line-height: 35px;
        }
        #mapSearch{
            margin-left: 10px;
        }
        #mapSearch button{
            width: 95px;
            background-color: #ffffff;
            color:#666666;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            border: 1px solid #DEDEDE;
        }
        .group{
            position: relative;
            text-align: left;
        }
        .row{
            position:relative;
            height: 60px;
            overflow: hidden;
            margin-bottom: 20px;
        }
        .head {
            position: absolute;
            font-size: 16px;
            color: #424242;
            font-weight: normal;
        }
        .body {
            padding: 0 100px 0 80px;
        }
        .body a{
            float: left;
            margin: 0 40px 9px 0;
            height: 18px;
            color:#999999;
            text-decoration: none;
        }
        .body a:hover{
            color:#2C79CB;
            cursor: pointer;
        }
        .foot{
            position:absolute;
            right: 0;
            color:#999999;
        }
        .foot span{
            cursor: pointer;
        }
        .img{
            width: 370px;
            height: 278px;
            position: relative;
        }
    
        .housing-intro{
            padding:24px 28px 20px 26px;
            text-align: left;
        }
        .housing-intro .community-name{
            float:left;
            width: 95%;
            //height: 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 22px;  
            white-space:nowrap;
            text-overflow:ellipsis; 
            overflow:hidden;
            cursor: pointer;
        }
    
        .housing-intro .housing-price{
            float: right;
            width: 130px;
            height: 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FF0000;
            line-height: 22px;
        }
    
        .maincontent .desc .housing-addr{
            padding: 20px 0px 18px 27px;
            height: 13px;
            text-align: left;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 22px;
        }
    
        .maincontent .desc .housing-props{
            padding:0px 27px 25px 27px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 30px;
            height: 30px;
        }
        .maincontent .el-col-8{
            width: 370px; 
            margin-bottom: 20px;
            margin-left: 28px;
        }
    
        .maincontent .el-col-8:nth-child(3n+1){
            margin-left: 0;
        }
        .maincontent .el-button--mini{
            padding: 7px;
        }
        #page{
            margin-top: 30px;
            margin-bottom: 40px;
        }
    
    
    }
        /* 导航图片 */
        .banner {
        width: 100%;
        position: relative;
        height: 290px;
        margin: 146px auto 0;
    }
    
    .banner-search {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 100px;
        z-index: 99;
        height:85px;
    }
    
    .banner-imgs {
        height: 100%;
        width: 100%;
        
    }
    
    .banner-img .el-carousel__indicators {
        z-index: 10000;
    }
    
    .banner .banner-title {
        height: 130px;
        margin-bottom: 50px;
    }
    .search-item {
        width: 791px;
        min-width: 750px;
        max-width: 1000px;
        text-align: center;
        margin: 0 auto;
        background: rgba(255, 255, 255, 0);
        border-radius: 10px;
        padding: 19px 25px 18px 23px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 22px;
        align-items: center;
    }
    
    .search-item div{
        width: 29px;
        height: 4px;
        background:#ffffff;
        margin: 11px auto;
    }
    </style>